/* eslint-disable */
import ls from 'local-storage';
import Vue from 'vue';
import useVueCompositionApi from '@/js/common/plugins/use-vue-composition-api';

import SearchRouter from '@/js/common/Domain/Router/SearchRouter';
import toLocalStorageTourCriteriaHydrator from '@/js/common/Domain/Hydrator/toLocalStorageTourCriteria';
import searchHistoryService from '@/js/common/Domain/Service/searchHistory';

import toRouterHotelHydrator from '@/js/common/Domain/Hydrator/toRouterHotel';
import toRouterHydrator from '@/js/common/components/hotelOffersSearch/router/toRouter';

import tourCriteriaService from '@/js/common/Domain/Service/tourCriteria';
import DataLayerAnalytics from '@/js/common/Domain/Service/DataLayerAnalytics';
import HotelOffersTab from '@ve/components/hotelOffersTab/desktop/HotelOffersTab.vue';
import SearchFormAutocompleteView from './SearchFormAutocomplete';

const SearchFromAutocomplete = Backbone.View.extend({
    initialize: function (options) {
        useVueCompositionApi();
        this.isGroupSearchAllowed = options.isGroupSearchAllowed;
        tourCriteriaService.clearTourCriteriaChangedFields();
        this.initModels();
        this.initEvents();
        this.initDomEvents();
        this.loadFormData();
        this.trackSearchFormView();
        this.initVueComponents();
    },
    initModels() {
        console.time('init');
        const self = this;

        this.searchFormView = new SearchFormAutocompleteView({ 
                searchFormSearchType: 'serp_hotel',
                isGroupSearchAllowed: this.isGroupSearchAllowed,
            });
        this.model = this.searchFormView.model;
        this.dataLayerAnalytics = new DataLayerAnalytics();
    },
    initEvents() {
        this.model.get('departureCity')?.on('change:model', $.proxy(this.model.departureCityChanged, this));
        this.model.get('countries')?.on('change:model', $.proxy(this.model.countriesChanged, this));
        this.model.get('resorts')?.on('change:model', $.proxy(this.model.resortsChangedForCriteria, this));
    },
    initDomEvents() {
        const self = this;
        $('#startSearch').on('click', () => {
            self.formSubmit();
        });
    },
    formSubmit() {
        const self = this;
        const currentTourCriteria = self.model.getTourCriteria();
        let paramsForRouter;
        const paramsForLocalStorage = toLocalStorageTourCriteriaHydrator(currentTourCriteria);
        let goToUrl;
        const router = new SearchRouter().getInstance();

        if (currentTourCriteria.isValid() && self.searchFormView.isValid()) {
            $.cookie('requestFromMainPage', true, { path: '/', domain: 'all' });
            $.cookie('markSearchSource', true, { path: '/', domain: 'all' });

            ls.set('tourCriteria__hotelOffers', paramsForLocalStorage);

            searchHistoryService.addSearch(currentTourCriteria);

            if (currentTourCriteria.get('hotels') && currentTourCriteria.get('hotels').length == 1) {
                paramsForRouter = toRouterHotelHydrator({ tourCriteria: currentTourCriteria });
                goToUrl = `/goto/hotel/${currentTourCriteria.get('hotels').at(0).get('id')}#?${$.param(paramsForRouter)}`;
            } else {
                paramsForRouter = toRouterHydrator(currentTourCriteria);
                goToUrl = `/hotels/search#?${$.param(paramsForRouter)}`;
            }

            this.dataLayerAnalytics.clickSearchButtonEvent();

            router.go(goToUrl);
        }
    },
    loadTourCriteriaWithFormData(params) {
        const success = (tourCriteria) => {
            this.model.setTourCriteria(tourCriteria);
        };

        tourCriteriaService.loadTourCriteriaWithFormData(params, {
            success: success.bind(this),
            error(tourCriteria) {},
        });
    },
    loadFormData() {
        let setTourCriteria;
        let tourCriteriaFromLocalStorage;

        this.model.get('countries')?.setNull();
        this.model.get('resorts')?.setNull();
        this.model.get('hotels')?.setNull();
        this.model.get('checkInDateRange')?.setNull();
        this.model.get('nightRange')?.setNull();
        this.model.get('touristGroup')?.setNull();
        this.model.get('hotelCategories')?.setNull();
        this.model.get('meals')?.setNull();
        this.model.get('priceRange')?.setNull();

        if (typeof window.appConfig.defaultCountryId === 'undefined' && typeof window.appConfig.defaultResorts === 'undefined') {
            tourCriteriaFromLocalStorage = ls.get('tourCriteria__hotelOffers');
        }

        setTourCriteria = tourCriteriaFromLocalStorage || {};

        if (typeof (window.appConfig.defaultTourCriteria) !== 'undefined') {
            $.extend(setTourCriteria, window.appConfig.defaultTourCriteria);
        }

        this.loadTourCriteriaWithFormData({
            setTourCriteria,
        });
    },
    trackSearchFormView() {
        //fixed
        this.dataLayerAnalytics.generateEvent('cacheResults', false);
        this.dataLayerAnalytics.preSearchPagePath();
    },
    initVueComponents() {
        new Vue({
            render: (h) => h(HotelOffersTab, {
                props: {
                    isActive: true,
                }
            })
        })?.$mount('.js-hotel-offers-tab');
    },
});

export default SearchFromAutocomplete;